export const MEMBERSHIP_ACTION_TYPE = {
	// REDUCER TYPES
	registerMembership:'registerMembership',
	registerMembershipIdle:'registerMembershipIdle',
	getMembership:'getMembership',
	updateMembership:'updateMembership',
	updateMembershipPlan:'updateMembershipPlan',
	updateMembershipIdle:'updateMembershipIdle',
	updateMembershipPlanIdle:'updateMembershipPlanIdle',
	allMembershipPlan:'allMembershipPlan',
	createMembershipByAdmin:'createMembershipByAdmin',
	createMembershipByAdminIdle:'createMembershipByAdminIdle',
	getAllMembershipPlanByAdmin:'getAllMembershipPlanByAdmin',
	retryForceMembershipByAdmin:'retryForceMembershipByAdmin',
	deleteMembershipPlan:'deleteMembershipPlan',
	deleteMembershipPlanIdle:'deleteMembershipPlanIdle',
	syncMembershipWithStripe:'syncMembershipWithStripe',
	syncMembershipWithStripeIdle:'syncMembershipWithStripeIdle',
	resetPlanLimit:'resetPlanLimit',
	resetPlanLimitIdle:'resetPlanLimitIdle',
	addNotes:'addNotes',
	sendBulkReminders:'sendBulkReminders',
	sendReminder:'sendReminder',
	retryPayment:'retryPayment',
	cancelSubscription:'cancelSubscription',
	assignComplimentaryPlan:'assignComplimentaryPlan',
	removeComplimentaryPlan:'removeComplimentaryPlan',
	getComplimentaryPlan:'getComplimentaryPlan',
};
